import { columns } from './Collaborators.enums';
import { NameContainer } from './Collaborators.styles';
import { ResultText } from './components/CollaboratorsTable/CollaboratorsTable.styles';
import { StatusRow } from './components/StatusRow/StatusRow';

const renderResult = (requireAttention: any) => {
	if (requireAttention === null || requireAttention === undefined) {
		return (
			<ResultText key={requireAttention} type="info">
				Sin respuesta
			</ResultText>
		);
	} else if (requireAttention) {
		return (
			<ResultText key={requireAttention} type="danger">
				Requiere atención
			</ResultText>
		);
	}

	return 'No requiere atención';
};

const renderName = (
	employee: any,
	handleOpenEmployeeDetail: (employee: any) => void,
) => {
	return (
		<NameContainer
			key={employee.name}
			onClick={() => handleOpenEmployeeDetail(employee)}
		>
			{employee.name}
		</NameContainer>
	);
};

export const formattedRows = (
	data: any,
	sequence: number | undefined,
	handleOpenEmployeeDetail: (employee: any) => void,
) => {
	return (
		data?.employees?.map((employee: any) => ({
			disabledCheckbox:
				!employee.requireAttention ||
				(employee.requireAttention && employee.status !== undefined),
			id: employee.id,
			campaignAnswerId: employee.campaignAnswerId,
			name: renderName(employee, handleOpenEmployeeDetail),
			position: employee?.position ?? '-',
			branchOfficeName: employee.branchOfficeName,
			result: renderResult(employee.requireAttention),
			status: (
				<StatusRow
					key={employee.riskLevel ?? 'N/A'}
					employee={employee}
					type={sequence === 0 ? 'status' : 'riskLevel'}
				/>
			),
		})) ?? []
	);
};

export const formattedColumns = (sequence: number | undefined) => {
	return [
		...columns,
		{
			id: 'status',
			label: sequence === 0 ? 'Estatus' : 'Nivel de riesgo',
			width: '200px',
		},
	];
};
